<template>
	<app-modal v-if="show" @close="closeModal" title="" @click.stop="">
		<template v-slot:header>
			<span class="mr-2">Address Management - {{ order.customer.phone }}</span>
			<app-button class="btn btn-primary transparent" @click="resetAddress"> New Address </app-button>
		</template>
		<div style="width: 750px; max-height: 800px">
			<div v-if="!selectedAddress.id" class="text-center">Creating New Address</div>
			<div class="w-full flex items-center justify-around mb-2 mx-2 px-2">
				<app-input
					v-if="selectedAddress.id"
					name="Id"
					placeholder="Id"
					class="w-24"
					v-model="selectedAddress.id"
					disabled
				/>
				<app-geo-search-select
					name="Street"
					label="Street"
					:placeholder="selectedAddress.addressStreet"
					@placechanged="getAddressData"
				/>
				<app-input name="Details" placeholder="Details" v-model="selectedAddress.addressDetails" />
				<app-checkbox name="Is Active" label="Is Active" v-model="selectedAddress.active" />
				<app-checkbox name="Is Primary" label="Is Primary" v-model="selectedAddress.primary" />
				<app-button class="btn btn-success" @click="submitAddress">
					{{ selectedAddress.id ? 'Save' : 'Create' }}
				</app-button>
			</div>
			<div>
				<app-table
					class="large"
					:columns="columns"
					:data="addresses"
					track-by="addressStreet"
					:selected-item-value="order.address"
				>
					<template v-slot:addressStreet="{ item }">
						<span>{{ item.addressStreet }}</span>
					</template>
					<template v-slot:addressDetails="{ item }">
						<span>{{ item.addressDetails }}</span>
					</template>
					<template v-slot:active="{ item }">
						<app-checkbox disabled :model-value="item.active" />
					</template>
					<template v-slot:primary="{ item }">
						<app-checkbox disabled :model-value="item.primary" />
					</template>
					<template v-slot:actions="{ item }">
						<app-button
							icon="assign"
							class="btn btn-success transparent mr-2"
							@click="updateOrderAddress(item.id)"
						/>
						<app-button
							icon="pencil"
							class="btn btn-info transparent mr-2"
							@click="selectedAddress = { ...item }"
						/>
						<app-confirmation
							title="Are you sure you want to delete this address?"
							placement="left"
							@confirm="deleteUserAddress(item)"
						>
							<app-button icon="trash" class="btn btn-warning transparent" />
						</app-confirmation>
					</template>
				</app-table>
			</div>
		</div>
	</app-modal>
</template>

<script>
	import AppModal from '@/components/app/AppModal';
	import constants from '@/constants/orders';
	import AppTable from '@/components/app/AppTable';
	import AppInput from '@/components/app/AppInput';
	import AppButton from '@/components/app/AppButton';
	import CustomerService from '@/services/CustomerService';
	import OrderService from '@/services/OrderService';
	import AppCheckbox from '@/components/app/AppCheckbox';
	import AppGeoSearchSelect from '@/components/app/AppGeoSearchSelect';
	import AppConfirmation from '@/components/app/AppConfirmation';

	const DEFAULT_ADDRESS = { active: true };

	export default {
		name: 'AddressManagementModal',
		components: { AppConfirmation, AppGeoSearchSelect, AppCheckbox, AppButton, AppInput, AppTable, AppModal },
		emits: ['close'],
		props: {
			show: {},
			order: {},
		},
		data: () => ({
			columns: constants.addressColumns,
			addresses: [],
			selectedAddress: DEFAULT_ADDRESS,
			showDeletePrompt: false,
			addressIdToDelete: null,
		}),
		methods: {
			getAddresses() {
				CustomerService.getAddresses(this.order.customer.id).then((response) => {
					this.addresses = response;
					this.selectedAddress = {
						...response.find((address) => address.addressStreet === this.order.address),
					};
				});
			},

			getAddressData(street) {
				this.selectedAddress.latitude = street.latitude;
				this.selectedAddress.longitude = street.longitude;
				this.selectedAddress.addressStreet = street.route + ' ' + street.locality;
			},

			saveUserAddress(address) {
				CustomerService.updateAddress(this.order.customer.id, address)
					.then(() => {
						this.updateOrderAddress(address.id);
						let index = this.addresses.findIndex((_address) => _address.id === address.id);
						this.addresses[index] = address;
					})
					.catch((e) => {
						this.$notificationService.error(e);
					});
			},

			createUserAddress(address) {
				CustomerService.createAddress(this.order.customer.id, address)
					.then((res) => {
						this.updateOrderAddress(res.id);
						this.addresses.unshift(res);
					})
					.catch((e) => {
						this.$notificationService.error(e);
					});
			},

			deleteUserAddress() {
				CustomerService.deleteAddress(this.selectedAddress.id)
					.then(() => {
						let objIndex = this.addresses.findIndex((obj) => obj.id === this.selectedAddress.id);
						this.addresses.splice(objIndex, 1);
						this.$notificationService.success('Address deleted successfully!');
						this.showDeletePrompt = false;
					})
					.catch((e) => {
						this.$notificationService.error(e);
					});
			},

			updateOrderAddress(addressId) {
				OrderService.updateOrderAddress(this.order.orderID, addressId)
					.then((res) => {
						this.updateAddressLoading = false;
						this.$notificationService.success('Address assigned successfully!');
						this.$emit('addressUpdate', res);
					})
					.catch((e) => {
						this.updateAddressLoading = false;
						this.$notificationService.error(e);
					});
			},
			submitAddress() {
				if (this.selectedAddress.id) {
					this.saveUserAddress(this.selectedAddress);
				} else {
					this.createUserAddress(this.selectedAddress);
				}
			},
			deletePrompt(item) {
				this.selectedAddress = item;
				this.showDeletePrompt = true;
			},
			closeModal() {
				this.$emit('close');
			},
			resetAddress() {
				this.selectedAddress = { ...DEFAULT_ADDRESS };
			},
		},
		mounted() {
			this.getAddresses();
		},
	};
</script>

<style scoped></style>
